"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
require("./data.component.scss");
var common_1 = require("@angular/common");
var router_1 = require("@angular/router");
var authentication_service_1 = require("../core/authentication/authentication.service");
var patient_data_component_1 = require("./patient/patient.data.component");
var device_data_component_1 = require("./device-data/device-data.component");
var DataComponent = /** @class */ (function () {
    function DataComponent(authService, route, router, location) {
        this.authService = authService;
        this.router = router;
        this.location = location;
        this.patientNumber = null;
        this.selectedIndex = 0;
        var patientNumberStr = route.snapshot.params['patientNumber'];
        if (!patientNumberStr) {
            if (this.authService.hasRole("physician" /* PHYSICIAN */, "service_engineer" /* SERVICE_ENGINEER */, "admin" /* ADMIN */)) {
                var lastPatient = window.sessionStorage.getItem('nano-last-patient');
                if (lastPatient) {
                    this.patientNumber = parseInt(lastPatient, 10);
                    this.updateUrlWithPatientNumber();
                }
            }
            else if (this.authService.credentials &&
                this.authService.credentials.patientNumber !== null) {
                this.patientNumber = this.authService.credentials.patientNumber;
                this.updateUrlWithPatientNumber();
            }
        }
        else {
            this.patientNumber = patientNumberStr ? parseInt(patientNumberStr, 10) : -1;
        }
    }
    DataComponent.prototype.onTabChangeDone = function () {
        switch (this.selectedIndex) {
            case 0:
                this.patientDataComponent.drawGraph();
                break;
            case 1:
                this.deviceDataComponent.drawGraph();
                break;
        }
    };
    DataComponent.prototype.updateUrlWithPatientNumber = function () {
        this.location.go(this.router.createUrlTree([this.router.url, this.patientNumber]).toString());
    };
    tslib_1.__decorate([
        core_1.ViewChild(patient_data_component_1.PatientDataComponent),
        tslib_1.__metadata("design:type", Object)
    ], DataComponent.prototype, "patientDataComponent", void 0);
    tslib_1.__decorate([
        core_1.ViewChild(device_data_component_1.DeviceDataComponent),
        tslib_1.__metadata("design:type", Object)
    ], DataComponent.prototype, "deviceDataComponent", void 0);
    DataComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'nano-data',
            template: require('./data.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [authentication_service_1.AuthenticationService,
            router_1.ActivatedRoute, router_1.Router, common_1.Location])
    ], DataComponent);
    return DataComponent;
}());
exports.DataComponent = DataComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/data/data.component.ts
// module id = 272
// module chunks = 0